module.exports = __webpack_public_path__ + "static/media/brand_logo3.1490ede5.jpg";